import type { CombatEffectSnapshot } from "@frontier/protocol/contracts";

export interface VisibleCombatEffect extends CombatEffectSnapshot {
  alpha: number;
}

export function visibleCombatEffects(
  effects: readonly CombatEffectSnapshot[],
  elapsedSeconds: number,
): VisibleCombatEffect[] {
  const elapsed = Math.max(0, elapsedSeconds);
  return effects.flatMap((effect) => {
    const remaining = effect.remaining - elapsed;
    return remaining > 0
      ? [{ ...effect, remaining, alpha: Math.min(0.7, remaining * 2) }]
      : [];
  });
}
